(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-quantity-input]').forEach((input) => {
    const clampQuantity = () => {
      if (input.value === '' || !input.hasAttribute('max')) return;

      const value = Number.parseInt(input.value, 10);
      const maximum = Number.parseInt(input.max, 10);
      if (!Number.isFinite(value) || !Number.isFinite(maximum)) return;

      input.value = String(Math.min(Math.max(value, 0), maximum));
    };

    input.addEventListener('input', clampQuantity);
    input.addEventListener('change', clampQuantity);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-header"]) return;
  try {
    
  if (!window.iliWishlist) {
    const wishlistKey = 'iliWishlist';

    const readWishlist = () => {
      try {
        const stored = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
        return Array.isArray(stored)
          ? stored.filter((handle) => typeof handle === 'string' && handle.length > 0).slice(0, 100)
          : [];
      } catch (error) {
        return [];
      }
    };

    const syncWishlist = () => {
      const handles = readWishlist();

      document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
        count.textContent = String(handles.length);
      });

      document.querySelectorAll('[data-wishlist-link]').forEach((link) => {
        const template = link.dataset.countLabel || 'Wishlist, __count__ saved';
        link.setAttribute('aria-label', template.replace('__count__', String(handles.length)));
      });

      document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
        const active = handles.includes(button.dataset.productHandle);
        const label = active ? button.dataset.removeLabel : button.dataset.addLabel;
        const text = button.querySelector('[data-wishlist-label]');
        const icon = button.querySelector('[data-wishlist-icon]');

        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        if (label) button.setAttribute('aria-label', label);
        if (text && label) text.textContent = label;
        if (icon) icon.textContent = active ? '♥' : '♡';
      });
    };

    const writeWishlist = (handles) => {
      localStorage.setItem(wishlistKey, JSON.stringify(handles.slice(0, 100)));
      syncWishlist();
      document.dispatchEvent(new CustomEvent('ili:wishlist-updated', { detail: { handles } }));
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-wishlist-toggle]');
      if (!button) return;

      const handle = button.dataset.productHandle;
      if (!handle) return;

      event.preventDefault();
      const handles = readWishlist();
      const nextHandles = handles.includes(handle)
        ? handles.filter((item) => item !== handle)
        : [handle].concat(handles);

      writeWishlist(nextHandles);
    });

    window.addEventListener('storage', syncWishlist);
    window.iliWishlist = {
      read: readWishlist,
      sync: syncWishlist
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncWishlist);
    } else {
      syncWishlist();
    }
  } else {
    window.iliWishlist.sync();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const select = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    const comparePrice = section.querySelector('[data-compare-price]');
    const stock = section.querySelector('[data-product-stock]');
    const sku = section.querySelector('[data-product-sku]');
    const quantityInput = section.querySelector('[data-quantity-input]');
    const quantityLimit = section.querySelector('[data-quantity-limit]');
    const addButton = section.querySelector('[data-add-to-cart]');
    const dynamicCheckout = section.querySelector('.product-page__dynamic-checkout');

    const clampQuantity = () => {
      if (!quantityInput || quantityInput.value === '') return;

      const value = Number.parseInt(quantityInput.value, 10);
      if (!Number.isFinite(value)) return;

      const maximum = Number.parseInt(quantityInput.max, 10);
      const cappedValue = Number.isFinite(maximum) ? Math.min(value, maximum) : value;
      quantityInput.value = String(Math.max(cappedValue, 1));
    };

    const updatePurchaseControls = (variantData) => {
      const available = variantData.available === 'true';
      const inventoryLimited = variantData.inventoryLimited === 'true';
      const parsedLimit = Number.parseInt(variantData.quantityLimit, 10);
      const limit = Number.isFinite(parsedLimit) ? Math.max(parsedLimit, 0) : 0;
      const canAdd = available && (!inventoryLimited || limit > 0);

      if (quantityInput) {
        if (inventoryLimited) {
          quantityInput.max = String(limit);
        } else {
          quantityInput.removeAttribute('max');
        }

        quantityInput.disabled = !canAdd;
        clampQuantity();
      }

      if (quantityLimit) {
        quantityLimit.hidden = !inventoryLimited;

        if (inventoryLimited) {
          quantityLimit.textContent = limit > 0
            ? section.dataset.inventoryLimitTemplate.replace('__quantity__', String(limit))
            : section.dataset.inventoryLimitReachedMessage;
        }
      }

      if (addButton) {
        addButton.disabled = !canAdd;

        if (canAdd) {
          addButton.textContent = addButton.dataset.addLabel;
        } else if (available) {
          addButton.textContent = addButton.dataset.limitReachedLabel;
        } else {
          addButton.textContent = addButton.dataset.soldOutLabel;
        }
      }

      if (dynamicCheckout) dynamicCheckout.hidden = !canAdd;

      return available;
    };

    const updateVariant = (option) => {
      if (!option) return;

      if (price) price.textContent = option.dataset.price;

      if (comparePrice) {
        comparePrice.textContent = option.dataset.compareAt;
        comparePrice.hidden = !option.dataset.compareAt;
      }

      const available = updatePurchaseControls(option.dataset);

      if (stock) {
        stock.textContent = option.dataset.stock;
        stock.classList.toggle('product-page__stock--sold-out', !available);
      }

      if (sku) sku.textContent = option.dataset.sku;

      if (option.dataset.mediaId) {
        const media = section.querySelector('[data-media-id="' + option.dataset.mediaId + '"]');
        if (media) media.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      if (option.dataset.url) history.replaceState({}, '', option.dataset.url);
    };

    const initialVariantData = select
      ? select.selectedOptions[0].dataset
      : {
          available: section.dataset.currentAvailable,
          inventoryLimited: section.dataset.currentInventoryLimited,
          quantityLimit: section.dataset.currentQuantityLimit
        };

    updatePurchaseControls(initialVariantData);

    if (select) {
      select.addEventListener('change', () => updateVariant(select.selectedOptions[0]));
    }

    if (quantityInput) {
      quantityInput.addEventListener('input', clampQuantity);
      quantityInput.addEventListener('change', clampQuantity);
    }

    if (addButton && addButton.form) {
      addButton.form.addEventListener('submit', (event) => {
        if (addButton.disabled) event.preventDefault();
        clampQuantity();
      });
    }

    try {
      const recentlyViewedKey = 'iliRecentlyViewed';
      const handle = section.dataset.productHandle;
      const stored = JSON.parse(localStorage.getItem(recentlyViewedKey) || '[]');
      const handles = Array.isArray(stored) ? stored : [];
      const nextHandles = [handle].concat(handles.filter((item) => item !== handle)).slice(0, 8);
      localStorage.setItem(recentlyViewedKey, JSON.stringify(nextHandles));
      document.dispatchEvent(new CustomEvent('ili:recently-viewed-updated'));
    } catch (error) {
      // Browsing history is optional when browser storage is unavailable.
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
  document.querySelectorAll('[data-wishlist-page]').forEach((section) => {
    const grid = section.querySelector('[data-wishlist-grid]');
    const empty = section.querySelector('[data-wishlist-empty]');
    const loading = section.querySelector('[data-wishlist-loading]');
    const currency = section.dataset.currency || 'GBP';
    const locale = section.dataset.locale || 'en-GB';
    const addLabel = section.dataset.addLabel;
    const removeLabel = section.dataset.removeLabel;
    let renderVersion = 0;

    const readHandles = () => {
      if (window.iliWishlist) return window.iliWishlist.read();

      try {
        const stored = JSON.parse(localStorage.getItem('iliWishlist') || '[]');
        return Array.isArray(stored) ? stored : [];
      } catch (error) {
        return [];
      }
    };

    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        }).format(Number(cents || 0) / 100);
      } catch (error) {
        return '£' + (Number(cents || 0) / 100).toFixed(2);
      }
    };

    const productUrl = (handle) => {
      const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      return root + 'products/' + encodeURIComponent(handle);
    };

    const fetchProduct = (handle) => fetch(productUrl(handle) + '.js').then((response) => {
      if (!response.ok) throw new Error('Product unavailable');
      return response.json();
    });

    const createCard = (product) => {
      const card = document.createElement('article');
      card.className = 'product-card';

      const wishlistButton = document.createElement('button');
      wishlistButton.className = 'wishlist-toggle wishlist-toggle--card';
      wishlistButton.type = 'button';
      wishlistButton.dataset.wishlistToggle = '';
      wishlistButton.dataset.productHandle = product.handle;
      wishlistButton.dataset.addLabel = addLabel;
      wishlistButton.dataset.removeLabel = removeLabel;
      wishlistButton.setAttribute('aria-label', removeLabel);
      wishlistButton.setAttribute('aria-pressed', 'true');

      const icon = document.createElement('span');
      icon.dataset.wishlistIcon = '';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '♥';
      wishlistButton.appendChild(icon);

      const imageLink = document.createElement('a');
      imageLink.className = 'product-card__image-link';
      imageLink.href = productUrl(product.handle);

      if (product.featured_image) {
        const image = document.createElement('img');
        image.className = 'product-card__image';
        image.src = product.featured_image;
        image.alt = product.title;
        image.loading = 'lazy';
        imageLink.appendChild(image);
      } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'product-card__placeholder';
        placeholder.textContent = product.title;
        imageLink.appendChild(placeholder);
      }

      const content = document.createElement('div');
      content.className = 'product-card__content';

      if (product.vendor) {
        const vendor = document.createElement('div');
        vendor.className = 'product-card__vendor';
        vendor.textContent = product.vendor;
        content.appendChild(vendor);
      }

      const title = document.createElement('a');
      title.className = 'product-card__title';
      title.href = productUrl(product.handle);
      title.textContent = product.title;

      const price = document.createElement('div');
      price.className = 'product-card__price';
      price.textContent = formatMoney(product.price);

      content.appendChild(title);
      content.appendChild(price);
      card.appendChild(wishlistButton);
      card.appendChild(imageLink);
      card.appendChild(content);
      return card;
    };

    const renderWishlist = async () => {
      const version = ++renderVersion;
      const handles = readHandles();

      grid.replaceChildren();
      grid.hidden = true;
      empty.hidden = true;
      loading.hidden = handles.length === 0;

      if (handles.length === 0) {
        loading.hidden = true;
        empty.hidden = false;
        return;
      }

      const results = await Promise.allSettled(handles.map(fetchProduct));
      if (version !== renderVersion) return;

      const products = results
        .filter((result) => result.status === 'fulfilled')
        .map((result) => result.value);

      loading.hidden = true;

      if (products.length === 0) {
        empty.hidden = false;
        return;
      }

      products.forEach((product) => grid.appendChild(createCard(product)));
      grid.hidden = false;
      if (window.iliWishlist) window.iliWishlist.sync();
    };

    document.addEventListener('ili:wishlist-updated', renderWishlist);
    renderWishlist();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class ProductRecommendations extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';

          if (this.querySelector('[data-similar-watches-content]')) {
            this.setupCarousel();
            return;
          }

          if (!this.dataset.url) return;

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const recommendations = html.querySelector('product-recommendations');

              if (!recommendations || !recommendations.innerHTML.trim()) return;

              this.innerHTML = recommendations.innerHTML;
              this.setupCarousel();
            })
            .catch(() => {});
        }

        setupCarousel() {
          const viewport = this.querySelector('[data-similar-watches-viewport]');
          const previous = this.querySelector('[data-similar-watches-previous]');
          const next = this.querySelector('[data-similar-watches-next]');

          if (!viewport || !previous || !next) return;

          const updateButtons = () => {
            const maximumScroll = Math.max(viewport.scrollWidth - viewport.clientWidth, 0);
            previous.disabled = viewport.scrollLeft <= 2;
            next.disabled = viewport.scrollLeft >= maximumScroll - 2;
          };

          const scrollCarousel = (direction) => {
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            viewport.scrollBy({
              left: direction * viewport.clientWidth * 0.82,
              behavior: reducedMotion ? 'auto' : 'smooth'
            });
          };

          previous.addEventListener('click', () => scrollCarousel(-1));
          next.addEventListener('click', () => scrollCarousel(1));
          viewport.addEventListener('scroll', updateButtons, { passive: true });
          window.addEventListener('resize', updateButtons);
          updateButtons();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-recently-viewed]').forEach((section) => {
    const grid = section.querySelector('[data-recently-viewed-grid]');
    const currentHandle = section.dataset.currentProduct;
    const currency = section.dataset.currency || 'GBP';
    const locale = section.dataset.locale || 'en-GB';
    const addLabel = section.dataset.addLabel;
    const removeLabel = section.dataset.removeLabel;
    let renderVersion = 0;

    const readHandles = () => {
      try {
        const stored = JSON.parse(localStorage.getItem('iliRecentlyViewed') || '[]');
        return Array.isArray(stored)
          ? stored.filter((handle) => typeof handle === 'string' && handle !== currentHandle).slice(0, 4)
          : [];
      } catch (error) {
        return [];
      }
    };

    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        }).format(Number(cents || 0) / 100);
      } catch (error) {
        return '£' + (Number(cents || 0) / 100).toFixed(2);
      }
    };

    const productUrl = (handle) => {
      const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      return root + 'products/' + encodeURIComponent(handle);
    };

    const fetchProduct = (handle) => fetch(productUrl(handle) + '.js').then((response) => {
      if (!response.ok) throw new Error('Product unavailable');
      return response.json();
    });

    const createCard = (product) => {
      const card = document.createElement('article');
      card.className = 'product-card';

      const wishlistButton = document.createElement('button');
      wishlistButton.className = 'wishlist-toggle wishlist-toggle--card';
      wishlistButton.type = 'button';
      wishlistButton.dataset.wishlistToggle = '';
      wishlistButton.dataset.productHandle = product.handle;
      wishlistButton.dataset.addLabel = addLabel;
      wishlistButton.dataset.removeLabel = removeLabel;
      wishlistButton.setAttribute('aria-label', addLabel);
      wishlistButton.setAttribute('aria-pressed', 'false');

      const icon = document.createElement('span');
      icon.dataset.wishlistIcon = '';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '♡';
      wishlistButton.appendChild(icon);

      const imageLink = document.createElement('a');
      imageLink.className = 'product-card__image-link';
      imageLink.href = productUrl(product.handle);

      if (product.featured_image) {
        const image = document.createElement('img');
        image.className = 'product-card__image';
        image.src = product.featured_image;
        image.alt = product.title;
        image.loading = 'lazy';
        imageLink.appendChild(image);
      } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'product-card__placeholder';
        placeholder.textContent = product.title;
        imageLink.appendChild(placeholder);
      }

      const content = document.createElement('div');
      content.className = 'product-card__content';

      if (product.vendor) {
        const vendor = document.createElement('div');
        vendor.className = 'product-card__vendor';
        vendor.textContent = product.vendor;
        content.appendChild(vendor);
      }

      const title = document.createElement('a');
      title.className = 'product-card__title';
      title.href = productUrl(product.handle);
      title.textContent = product.title;

      const price = document.createElement('div');
      price.className = 'product-card__price';
      price.textContent = formatMoney(product.price);

      content.appendChild(title);
      content.appendChild(price);
      card.appendChild(wishlistButton);
      card.appendChild(imageLink);
      card.appendChild(content);
      return card;
    };

    const renderRecentlyViewed = async () => {
      const version = ++renderVersion;
      const handles = readHandles();

      grid.replaceChildren();
      section.hidden = handles.length === 0;
      if (handles.length === 0) return;

      const results = await Promise.allSettled(handles.map(fetchProduct));
      if (version !== renderVersion) return;

      const products = results
        .filter((result) => result.status === 'fulfilled')
        .map((result) => result.value);

      grid.replaceChildren();
      products.forEach((product) => grid.appendChild(createCard(product)));
      section.hidden = products.length === 0;
      if (window.iliWishlist) window.iliWishlist.sync();
    };

    document.addEventListener('ili:recently-viewed-updated', renderRecentlyViewed);
    renderRecentlyViewed();
  });

  } catch(e) { console.error(e); }
})();
})();
